/**
 * 🔄 toSnakeCase: Converts a string to snake_case format
 * @param str - The string to convert
 * @returns The snake_case version of the string
 */
export const toSnakeCase = (str: string): string => {
  const result = str
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`) // Convert camelCase
    .replace(/^_/, '') // Remove leading underscore
    .replace(/_+/g, '_') // Replace multiple underscores with single
    .toLowerCase()
  return result
}

/**
 * 🔄 sanitizeHtmlUrls: Fixes URLs in HTML content to open in new tabs with proper protocols
 * @param html - The HTML string to sanitize
 * @returns The sanitized HTML string with fixed URLs
 */
export const sanitizeHtmlUrls = (html: string): string => {
  // Parse HTML and fix URLs
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  // Find all anchor tags
  const anchors = doc.querySelectorAll('a')

  anchors.forEach((anchor) => {
    const href = anchor.getAttribute('href')
    if (href) {
      // Add target="_blank" for external links
      anchor.setAttribute('target', '_blank')
      anchor.setAttribute('rel', 'noopener noreferrer')

      // Fix URLs that don't have protocol
      if (
        !href.startsWith('http://') &&
        !href.startsWith('https://') &&
        !href.startsWith('mailto:') &&
        !href.startsWith('tel:')
      ) {
        // Assume it's a web URL and add https://
        anchor.setAttribute('href', `https://${href}`)
      }
    }
  })

  // Return the sanitized HTML
  return doc.body.innerHTML
}
